/*German (Germany) locale*/
const de = {
	groupDelimiter:".",
	groupSize:3,
	decimalDelimiter:",",
	decimalSize:2,
	dateFormat:"%d.%n.%Y",
	timeFormat:"%H:%i",
	longDateFormat:"%j. %F %Y",
	fullDateFormat:"%j. %F %Y %H:%i",
	am:null,
	pm:null,
	price:"{obj} €",
	priceSettings:{
		groupDelimiter:".",
		groupSize:3,
		decimalDelimiter:",",
		decimalSize:2
	},
	calendar:{
		monthFull:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],
		monthShort:["Jan","Feb","Mrz","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],
		dayFull:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],
		dayShort:["So","Mo","Di","Mi","Do","Fr","Sa"],
		hours: "Stunden",
		minutes: "Minuten",
		done:"Fertig",
		clear: "Entfernen",
		today: "Heute"
	},

	dataExport:{
		page:"Seite",
		of:"aus"
	},
	PDFviewer:{
		of:"aus",
		automaticZoom:"Automatisch Zoom",
		actualSize:"Aktuelles Ausmaß",
		pageFit:"Seite Ausmaß",
		pageWidth:"Seite Breite",
		pageHeight:"Seite Höhe",
		enterPassword:"Passwort eingeben",
		passwordError:"Falsches passwort"
	},
	aria:{
		calendar:"Kalender",
		increaseValue:"Wert erhöhen",
		decreaseValue:"Wert verringern",
		navMonth:["Vorheriger Monat", "Nächsten Monat"],
		navYear:["Vorheriges Jahr", "Nächstes Jahr"],
		navDecade:["Zurück Jahrzehnt", "Als nächstes Jahrzehnt"],
		dateFormat:"%j. %F %Y",
		monthFormat:"%F %Y",
		yearFormat:"%Y",
		hourFormat:"Stunden: %H",
		minuteFormat:"Minuten: %i",
		removeItem:"Element entfernen",
		pages:["Erste Seite", "Vorherige Seite", "Folgeseite", "Letzte Seite"],
		page:"Seite",
		headermenu:"Titelmenü",
		openGroup:"Öffnen Spaltengruppe ",
		closeGroup:"Schließen Spaltengruppe ",
		closeTab:"Tab schließen",
		showTabs:"Weitere Tabs",
		resetTreeMap:"Zurück zur ursprünglichen Ansicht",
		navTreeMap:"Aufleveln",
		nextTab:"Weiter tab",
		prevTab:"Zurück tab",
		multitextSection:"Element hinzufügen",
		multitextextraSection:"Element entfernen",
		showChart:"Chart anzeigen",
		hideChart:"Chart verstecken",
		resizeChart:"Chart Größe ändern"
	},
	richtext:{
		underline: "Unterstreichen",
		bold: "Fettgedruckt",
		italic: "Kursiv"
	},
	combo:{
		select:"Auswählen",
		selectAll:"Alles auswählen",
		unselectAll:"Alles widerrufen"
	},
	message:{
		ok:"OK",
		cancel:"Abbrechen"
	},
	comments:{
		send: "Absenden",
		confirmMessage: "Der Kommentar wird entfernt. Sind Sie sicher?",
		edit: "Redigieren",
		remove: "Löschen",
		placeholder: "Geben Sie hier ein..",
		moreComments:"Mehr Kommentare"
	}
};

export default de;